// import './index.scss'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { createPortal } from "react-dom";
import slotsCasinoImg from './slotsCasinoPopUp.svg';
import closeButton from './closeButton.svg';
import { setSlotCasinoPopUp } from '../../store/slotCasinoPopUp/slotCasinoPopUp.slice'
import { setIsNavigationID, setIsNavigationName } from '../../store/navigationHeaderMenu/navigationHeaderMenu.slice'
const modalRoot = document.querySelector("#modal-root");



const SlotsCasinoPopUp = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const slotCasinoPopUp = useSelector((state) => state.slotCasinoPopUp);

  const handleCloseLobby = () => {
    dispatch(setSlotCasinoPopUp(false));
    dispatch(setIsNavigationID(''));
    dispatch(setIsNavigationName(''));
    navigate('/');
  }

  return createPortal (
    <>
      {(slotCasinoPopUp.isOpen && slotCasinoPopUp.allowed)&& 
        <div className=" absolute top-0 left-0 bottom-0 right-0 h-full w-full z-[3000] bg-bg_PopUpParentBg flex items-center justify-center font-lato">
          <div className="popUpOpenAnimation relative w-full max-w-[752px] h-[432px] bg-white text-base font-medium text-[black] shadow-[0px_4px_6px_rgba(0,0,0,0.25),inset_-3px_4px_6px_rgba(0,0,0,0.25)] flex justify-center items-center flex-col pt-0 pb-5 px-0 rounded-[30px] mx-5">
            <img className="absolute top-[-100px] " src={slotsCasinoImg} alt=''/>
            <img className="absolute right-[-22px] top-[-22px]" onClick={() => {handleCloseLobby();}} src={closeButton} alt=''/>
            <div className="flex justify-center not-italic font-bold text-lg leading-[22px] text-[#252B37] mt-[100px] font-lato">PLEASE NOTE</div>
            <div className="not-italic font-black text-[22px] leading-[26px] text-text_Primary mt-[11px]">(₹ 10 = 1 Point)</div>
            <div className="not-italic font-normal text-[15px] leading-[18px] text-[#252B37] mt-3.5">Welcome to your new casino lobby</div>
            <div className="not-italic font-normal text-[15px] leading-[18px] text-center text-[#252B37] max-w-[414px] mt-[35px] mx-4">Checkout the exciting Live Casino tables, Slots and much more, upto 200+ game and counting...</div>
            <div 
              className="shadow-[0px_4px_4px_rgba(0,0,0,0.25)] w-[280px] h-11 not-italic font-bold text-[15px] leading-[18px] text-white flex justify-center items-center mt-[52px] rounded-[15px] bg-bg_Primary" 
              onClick={() => dispatch(setSlotCasinoPopUp(false))}
            >OK, I AGREE !</div>
            
          </div>
        </div>
      }
    </>
    , modalRoot
  )
}

export default SlotsCasinoPopUp;
